import { render, staticRenderFns } from "./BtTimelineItem.vue?vue&type=template&id=d89d8b02&"
import script from "./BtTimelineItem.vue?vue&type=script&lang=js&"
export * from "./BtTimelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports